import React from "react";
import { Row, Col, Card, Tag } from "antd";

export type Agent = {
  id: string;
  agentUUID: string;
  aiAgentPublicApiUrl?: string;
  appId?: string;
  createdTime?: string;
  description: string;
  flow?: object | null;
  iconUrl?: string;
  instructions?: string;
  lastUpdatedTime?: string;
  name: string;
  settings?: string;
  subAgents?: object | null;
  tags?: string[];
  tenantId?: string;
  tools?: string;
  triggers?: object | null;
  usageLabel?: string;
  errorRateLabel?: string;
  misc?: string;
};

export interface AgentListViewProps {
  agents: Agent[];
  onSelectAgent: (agent: Agent) => void;
}

const AgentListView: React.FC<AgentListViewProps> = ({ agents, onSelectAgent }) => {
  return (
    <div style={{ padding: 54 }}>
      <Row gutter={[24, 24]}>
        {agents.map((agent) => (
          <Col key={agent.id} xs={24} sm={12} md={12} lg={8} xl={6}>
            <Card
              hoverable
              style={{ borderRadius: 16 }}
              onClick={() => onSelectAgent(agent)}
              bodyStyle={{ minHeight: 170 }}
            >
              <h3 style={{ marginBottom: 8 }}>{agent.name}</h3>
              <p style={{ fontSize: 12, color: "#666", minHeight: 40 }}>{agent.description}</p>

              {(agent.usageLabel != null || agent.errorRateLabel != null) && (
                <div style={{ marginTop: 12, marginBottom: 8 }}>
                  {agent.usageLabel != null && <Tag color="green">{agent.usageLabel}</Tag>}
                  {agent.errorRateLabel != null && <Tag color="red">{agent.errorRateLabel}</Tag>}
                </div>
              )}

              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {agent.tags?.map((tag) => (
                  <Tag
                    key={tag}
                    style={{
                      color: "rgb(114, 46, 209)",
                      backgroundColor: "rgb(249, 240, 255)",
                      borderRadius: 999,
                      border: "none",
                      padding: "2px 10px",
                      fontSize: 12,
                    }}
                  >
                    {tag}
                  </Tag>
                ))}
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default AgentListView;


